import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  max-width: 420px;
  width: 80vw;

  .title {
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${ ({ theme }) => theme.colors.primary };
    text-align: center;
  }

  .passes {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 45vh;
    overflow-y: auto;
  }

  .pass {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
    cursor: pointer;

    &.selected {
      border-color: ${ ({ theme }) => theme.colors.greenRadio };
      background-color: ${ ({ theme }) => theme.colors.lightGreen };
    }

    &.disabled {
      opacity: 0.5;
      cursor: default;
    }

    .name {
      font-weight: 700;
    }

    .info {
      font-size: 14px;
      color: ${ ({ theme }) => theme.colors.greyDark };
    }

    .error {
      font-size: 14px;
      color: ${ ({ theme }) => theme.colors.red };
    }
  }

  .empty {
    padding: 16px 0;
    text-align: center;
    color: ${ ({ theme }) => theme.colors.greyDark };
  }

  footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`
